import SchoolLogo from "../assets/images/coewarri.png";
import AffiliateLogo from "../assets/images/DELSU_LOGO.png";

export const InstitutionName = "College of Education, Warri";
export const AffiliateName =
  "Delta State University, Abraka";

export { SchoolLogo, AffiliateLogo };

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const paymentTypes = [
  {
    name: "School Fees - Full Payment",
    key: "full",
  },
  {
    name: "School Fees - First Instalment",
    key: "part",
  },
  {
    name: "School Fees - Second Instalment",
    key: "second_installment",
  },
  {
    name: "Late Payment",
    key: "late",
  },
  {
    name: "Additional Fee",
    value:'additional fee'
  },
];
